import { useContext, useEffect, useState } from "react";
import { Row, Col, Card, Button, Table, Badge, Modal } from 'react-bootstrap';
import { FaUsers, FaCar, FaSpinner, FaCalendarAlt, FaArrowUp, FaCheckCircle, FaCheck, FaTimes, FaFileAlt } from 'react-icons/fa';
import '../../../assets/css/Admin/AdminDashboard/AdminDashboard.css';
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';
import axios from "axios";
import AppContext from "../../../context/AppContext";

const AdminDashboard = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [pendingDrivers, setPendingDrivers] = useState([]);
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const handleViewDocs = (driver) => {
    setSelectedDriver(driver);
    setShowDocsModal(true);
  };

  const handleApprove = (driverId) => {

    const formData = new FormData();
    formData.append("id", driverId);
    axios.post(`${baseUrl}/admin/verifydriver/approveDriver`, formData, {
      headers: { Authorization: `Bearer ${authToken}` }
    })

      .then(() => {
        getPendingDrivers();
        setShowDocsModal(false);
      })
      .catch((error) => {
        console.log(error);
      });

  };

  const handleReject = (driverId) => {

    axios.post(`${baseUrl}/admin/verifydriver/rejectDriver/${driverId}`, {}, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(() => {
        getPendingDrivers();
        setShowDocsModal(false);
      })
      .catch((error) => {
        console.log(error);
      });

  };
  const getPendingDrivers = () => {

    axios.post(
      `${baseUrl}/admin/verifydriver/pendingDrivers`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {
        setPendingDrivers(response.data.drivers);
      })
      .catch((error) => {
        console.log(error);
      });

  };
  useEffect(() => {
    getPendingDrivers();
  }, []);
  return (
    <AdminMasterLayout screenName="dashboard">
      <div className="admin-dashboard-fullscreen-container">

        {/* Top Stats Row */}
        <Row className="mb-3">
          <Col lg={12}>
            <Card className="admin-dashboard-earnings-compact-card">
              <Card.Body className="admin-dashboard-earnings-compact-body">
                <div className="admin-dashboard-earnings-icon-small">
                  <span className="admin-dashboard-dollar-icon-small">$</span>
                </div>
                <div className="admin-dashboard-earnings-content-small">
                  <p className="admin-dashboard-earnings-label-small">Total Earnings</p>
                  <h2 className="admin-dashboard-earnings-value-small">Rs 145,230</h2>
                </div>
                <div className="admin-dashboard-earnings-change-small">
                  <FaArrowUp className="admin-dashboard-arrow-icon-small" />
                  <span className="admin-dashboard-change-text-small">12% increase</span>
                </div>
                <div className="admin-dashboard-earnings-status-small">
                  <FaCheckCircle className="admin-dashboard-check-icon-small" />
                  <span className="admin-dashboard-status-text-small">Booked</span>
                </div>
                <div className="admin-dashboard-earnings-action-small">
                  <Button className="admin-dashboard-approve-compact-btn">Approve</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Stats Cards Row */}
        <Row className="mb-3">
          <Col lg={3} md={6} className="mb-3 mb-lg-0">
            <Card className="admin-dashboard-stat-compact-card">
              <Card.Body className="admin-dashboard-stat-compact-body">
                <div className="admin-dashboard-stat-icon-small admin-dashboard-customers-icon-bg">
                  <FaUsers />
                </div>
                <p className="admin-dashboard-stat-label-small">Number of Customers</p>
                <h3 className="admin-dashboard-stat-value-small">06</h3>
                <p className="admin-dashboard-stat-sublabel-small">Total Registered</p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3 mb-lg-0">
            <Card className="admin-dashboard-stat-compact-card">
              <Card.Body className="admin-dashboard-stat-compact-body">
                <div className="admin-dashboard-stat-icon-small admin-dashboard-drivers-icon-bg">
                  <FaCar />
                </div>
                <p className="admin-dashboard-stat-label-small">Number of Drivers</p>
                <h3 className="admin-dashboard-stat-value-small">07</h3>
                <p className="admin-dashboard-stat-sublabel-small">Active Drivers</p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3 mb-lg-0">
            <Card className="admin-dashboard-stat-compact-card">
              <Card.Body className="admin-dashboard-stat-compact-body">
                <div className="admin-dashboard-stat-icon-small admin-dashboard-ongoing-icon-bg">
                  <FaSpinner />
                </div>
                <p className="admin-dashboard-stat-label-small">Ongoing Rides</p>
                <h3 className="admin-dashboard-stat-value-small">03</h3>
                <p className="admin-dashboard-stat-sublabel-small">No. of Rides Ongoing</p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6}>
            <Card className="admin-dashboard-stat-compact-card">
              <Card.Body className="admin-dashboard-stat-compact-body">
                <div className="admin-dashboard-stat-icon-small admin-dashboard-scheduled-icon-bg">
                  <FaCalendarAlt />
                </div>
                <p className="admin-dashboard-stat-label-small">Scheduled Rides</p>
                <h3 className="admin-dashboard-stat-value-small">01</h3>
                <p className="admin-dashboard-stat-sublabel-small">No. of Scheduled Rides</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Pending Driver Approvals Table */}
        <Row className="admin-dashboard-table-section-row">
          <Col lg={12}>
            <Card className="admin-dashboard-approvals-compact-card">
              <Card.Body className="admin-dashboard-approvals-compact-body">
                <h3 className="admin-dashboard-table-heading-small">Pending Driver Approvals</h3>
                <div className="admin-dashboard-table-wrapper">
                  <Table className="admin-dashboard-approvals-compact-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>DRIVER NAME</th>
                        <th>Persona Docs</th>
                        <th>DOCUMENTS</th>
                        <th>REGISTRATION DATE</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingDrivers.length > 0 ? (
                        pendingDrivers.map((driver, index) => (
                          <tr key={driver.id}>
                            <td>{index + 1}</td>

                            <td>
                              <div className="admin-dashboard-driver-info-small">
                                <div className="admin-dashboard-driver-avatar-small">
                                  {driver.drivername?.charAt(0)}
                                </div>

                                <span className="admin-dashboard-driver-name-small">
                                  {driver.tddriver?.drivername}
                                </span>
                              </div>
                            </td>

                            <td>
                              <Badge bg="info" className="admin-dashboard-status-badge-small">
                                {driver.status}
                              </Badge>
                            </td>

                            <td>
                              <Button
                                className="admin-dashboard-view-docs-btn"
                                size="sm"
                                onClick={() => handleViewDocs(driver)}
                              >
                                <FaFileAlt /> View Docs
                              </Button>
                            </td>

                            <td>
                              {new Date(driver.created_at).toLocaleDateString()}
                            </td>

                            <td>
                              <Badge
                                bg={
                                  driver.status === "approved"
                                    ? "success"
                                    : driver.status === "rejected"
                                      ? "danger"
                                      : "warning"
                                }
                                className="admin-dashboard-status-badge-small"
                              >
                                {driver.status}
                              </Badge>
                            </td>

                            <td>
                              <div className="admin-dashboard-action-buttons-small">
                                <Button
                                  className="admin-dashboard-approve-btn-small"
                                  size="sm"
                                  onClick={() => handleApprove(driver.id)}
                                >
                                  <FaCheck /> Approve
                                </Button>

                                <Button
                                  className="admin-dashboard-reject-btn-small"
                                  size="sm"
                                  onClick={() => handleReject(driver.id)}
                                >
                                  <FaTimes /> Reject
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No pending drivers found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

      </div>

      {/* Documents Modal */}
      {selectedDriver && (
        <Modal
          show={showDocsModal}
          onHide={() => setShowDocsModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedDriver.drivername}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="text-center">

              <h5>Vehicle Document</h5>

              <img
                src={`${baseUrl}/storage/${selectedDriver.vehicle_document}`}
                alt="Vehicle"
                className="img-fluid rounded"
                style={{ maxHeight: "450px" }}
              />

            </div>
          </Modal.Body>

          <Modal.Footer>

            <Button
              variant="danger"
              onClick={() => handleReject(selectedDriver.id)}
            >
              Reject
            </Button>

            <Button
              variant="success"
              onClick={() => handleApprove(selectedDriver.id)}
            >
              Approve
            </Button>

          </Modal.Footer>
        </Modal>
      )}

    </AdminMasterLayout>
  );
};

export default AdminDashboard;